import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Input } from 'framework-ui-components';
import DeleteIcon from 'framework-ui-components/Components/Icons/DeleteIcon';

class InputRicerca extends Component {
    state = {
        searchTerm: '',
    }

    onChangeSearch = (event) => {
        this.setState({ searchTerm: event.target.value }, () => {
            if (this.state.searchTerm == '') this.clickCerca();
        });
    }

    clickCerca = () => {
        this.props.onClickCerca && this.props.onClickCerca(this.state.searchTerm);
    }

    onSearchKeyDown = (event) => {
        if (event.keyCode == 13) {
            this.clickCerca();
        }
    }

    svuotaRicerca = (reload) => {
        this.setState({ searchTerm: '' }, () => reload && this.clickCerca());
        if (this.refInput.formattedField.current) this.refInput.formattedField.current.value = '';
        if (this.refInput.unformattedField.current) this.refInput.unformattedField.current.value = '';
    }

    render() {
        const { buttonText, title } = this.props;

        return (
            <Grid.Row className="mb-19">
                <Grid.Col md="9">
                    <Fragment>
                        <Input
                            title={title}
                            value={this.state.searchTerm}
                            autoFocus
                            ref={r => this.refInput = r}
                            onChange={this.onChangeSearch}
                            onKeyDown={this.onSearchKeyDown}
                        />
                        {this.state.searchTerm
                            && <Button icon onClick={() => this.svuotaRicerca(true)} className="deleteRicerca__icon"><DeleteIcon /></Button>
                        }
                    </Fragment>
                </Grid.Col>
                <Grid.Col md="3">
                    <Button primary flat onClick={this.clickCerca} className="mt-19">{buttonText}</Button>
                </Grid.Col>
            </Grid.Row>
        );
    }
}

InputRicerca.propTypes = {
    buttonText: PropTypes.string,
    onClickCerca: PropTypes.func,
    title: PropTypes.string,
};

InputRicerca.defaultProps = {
    title: 'Cerca',
    buttonText: 'Cerca',
};

export default InputRicerca;
